export default "__VITE_ASSET__393sYcpM__"